module.exports = __webpack_public_path__ + "static/img/coin.a6e001de.png";